/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface ISIMDashboard {
        sim: Models.ISIM;
        simId: number;
        slot: number;
        simPlan: Models.ISimPlan;
        remainingData: number;
    }

    interface IExtendedStream {
        streamId: number;
        source: string;
        sink: string;
    }

    export interface IMobileDeviceDashboard {
        networkNode: NetworkNode | Models.IHalElement<NetworkNode>;
        networkNodeType: NetworkNodeType;
        sims: ISIMDashboard[];
        currentStreams: IExtendedStream[];
    }

    export class MobileDeviceDashboard implements IMobileDeviceDashboard {
        public networkNode: NetworkNode;
        public networkNodeType: NetworkNodeType;
        public sims: ISIMDashboard[];
        public currentStreams: IExtendedStream[];

        public static Empty(): MobileDeviceDashboard {
            return new MobileDeviceDashboard();
        }

        /**
         * MobileDevice's empty constructor for automatic conversion from REST data.
         */
        constructor() {
            this.networkNode = new NetworkNode();
            this.networkNodeType = new NetworkNodeType();
            this.sims = new Array();
            this.currentStreams = new Array();
        }
    }
}
